/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Passkey_Last_UsedInputs */

const en_passkey_last_used = /** @type {(inputs: Passkey_Last_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last used ${i?.date}`)
};

const de_passkey_last_used = /** @type {(inputs: Passkey_Last_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zuletzt verwendet am ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Last used {date}" |
*
* @param {Passkey_Last_UsedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const passkey_last_used = /** @type {((inputs: Passkey_Last_UsedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passkey_Last_UsedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_passkey_last_used(inputs)
	return en_passkey_last_used(inputs)
});